import { createContext, useContext } from 'react'

const defaultValues = {
  background: 'default'
}

const ThemeContext = createContext(defaultValues)

export function useTheme() {
  return useContext(ThemeContext)
}

export default ThemeContext
